var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./UserBalanceHistoryModal.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-7e8e59a2!../../node_modules/vue-loader/lib/selector?type=template&index=0!./UserBalanceHistoryModal.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/modals/UserBalanceHistoryModal.vue
// module id = 263
// module chunks = 0